import styled from '@emotion/styled';

export const SpanHoverUnderline = styled.span({
  '&:hover': { textDecorationLine: 'underline' },
});
